import IconHOC from 'shared/legacy/icons/v2/IconHOC';
import { ReactComponent as CornerLeftUpIcon } from './cornerLeftUp.svg';

export const CornerLeftUp = IconHOC(CornerLeftUpIcon);
